/*
  WHICH ADDRESS IS OURS AND WHICH IS THEIRS (the Product Owner, 2026-10-09; MTR #509; project doc 113).

  "只要是我们内部看得到的链接…都是 my 开头的。如果是我们发给租客，他外部的任何东西都是 go 开头的。
   那这样子我们一看这个网址，我们自己也知道这是对内或对外。"

  my.stayoo.com is ours: the staff app, and a colleague's own view of any page.
  go.stayoo.com is theirs: every page a renter or the outside world opens, and every link we send.

  ONE SWITCH. go.stayoo.com needed a DNS record, a Railway domain and a map-key referrer before it
  served anything, so the address was built off (PR #510) and turned on once it answered (2026-10-09).
  It stays a setting — `VITE_RENTER_BASE` for the pages (read at build), `RENTER_BASE` for the
  servers — so going back is a setting, not a release. Only our two addresses are accepted: a typo
  must not send renters somewhere else, and an unrecognised value falls back to my.stayoo.com.
*/
export const STAFF_BASE = 'https://my.stayoo.com'
export const GO_BASE = 'https://go.stayoo.com'

const ACCEPTED = new Set([STAFF_BASE, GO_BASE])

const viteSetting = (() => { try { return import.meta.env?.VITE_RENTER_BASE ?? null } catch { return null } })()
const serverSetting = (() => { try { return globalThis.process?.env?.RENTER_BASE ?? null } catch { return null } })()

/** The address a renter is sent: go.stayoo.com once switched on, my.stayoo.com until then. */
function renterBaseFrom(setting) {
  const s = String(setting ?? '').trim().replace(/\/+$/, '')
  return ACCEPTED.has(s) ? s : STAFF_BASE
}

/*
  ON SINCE 2026-10-09 (go.stayoo.com answered: DNS, Railway domain, Mapbox referrer — MTR #509). The
  setting is now the way back: `RENTER_BASE=https://my.stayoo.com` (or the VITE_ one) returns renters
  to my.stayoo.com without a release. Anything else unrecognised still falls back to my.stayoo.com.
*/
export const RENTER_BASE = renterBaseFrom(viteSetting ?? serverSetting ?? GO_BASE)

/** Both of our addresses — what a server may be asked from, and what counts as "our own site". */
export const OUR_ORIGINS = Object.freeze([STAFF_BASE, GO_BASE])
export const OUR_HOSTS = Object.freeze(OUR_ORIGINS.map((o) => new URL(o).host))

/** True when `url` is a page on either of our addresses. */
export const isOurPage = (url) => typeof url === 'string' && OUR_ORIGINS.some((o) => url.startsWith(`${o}/`))
